var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnverified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 0C52.7646 0 68 15.2354 68 34C68 52.7646 52.7646 68 34 68C15.2354 68 0 52.7646 0 34C0 15.2354 15.2354 0 34 0Z",
    fill: "#D63636"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7431 14.6077H31.7539L33.0606 43.4646L36.8719 43.3557L37.7431 14.6077Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1438 48.5342L33.0059 48.5551L33.1897 52.8376H37.1438V48.5342Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnverified);
export default __webpack_public_path__ + "static/media/unverified.3dfe940043c76d3020bd953761a07c65.svg";
export { ForwardRef as ReactComponent };